const colors = [
    {
      shortcut: 'BLUE',
      shortname: 'blue',
      fr: 'Bleu',
      en: 'Blue',
      hex: '#0000FF', /** Ce bleu n'est pas du tout visible */
      displayHex: '#3030FF',
    },
    {
      shortcut: 'GREEN',
      shortname: 'green',
      fr: 'Vert',
      en: 'Green',
      hex: '#00FF00',
      displayHex: '#00FF00',
    },
    {
      shortcut: 'CYAN',
      shortname: 'cyan',
      fr: 'Cyan',
      en: 'Cyan',
      hex: '#00FFFF',
      displayHex: '#00FFFF',
    },
    {
      shortcut: 'RED',
      shortname: 'red',
      fr: 'Rouge',
      en: 'Red',
      hex: '#FF0000',
      displayHex: '#FF0000',
    },
    {
      shortcut: 'MAGENTA',
      shortname: 'magenta',
      fr: 'Magenta',
      en: 'Magenta',
      hex: '#FF00FF',
      displayHex: '#FF00FF',
    },
    {
      shortcut: 'YELLOW',
      shortname: 'yellow',
      fr: 'Jaune',
      en: 'Yellow',
      hex: '#FFFF00',
      displayHex: '#FFFF00',
    },
    {
      shortcut: 'WHITE',
      shortname: 'white',
      fr: 'Blanc',
      en: 'White',
      hex: '#FFFFFF',
      displayHex: '#FFFFFF',
    },
  ];
  
  export const getColorByColorIndex = (colorIndex) => {
    switch (true) {
      case colorIndex >= 0 && colorIndex < 7:
        return colors[colorIndex];
      default:
        return colors[6];
    }
  };
  
  export const getColorByShortcut = (shortcut) => {
    return colors.find((x) => x.shortcut === shortcut);
  };
  

  export const getAssetColorsByType = (type) =>  {
      switch (type)
      {
        case "empty":
          return {backcolor: "#000000", color:"#FFFFFF"};
          break;

        case "trjson":
          return {backcolor: "#900000", color:"#FFFFFF"};
          break;
        case "newtrjson":
          return {backcolor: "#FF8080", color:"#FFFFFF"};
          break;
        case "video":
          return {backcolor: "#000090", color:"#FFFFFF"};
          break;
        case "mp4zaudio":
          return {backcolor: "#000090", color:"#FFFFFF"};
          break;
        case "mp4zcp":
          return {backcolor: "#000090", color:"#FFFFFF"};
          break;
        case "st":
          return {backcolor: "#008000", color:"#FFFFFF"};
          break;
        case "oldst":
          return {backcolor: "#10A010", color:"#FFFFFF"};
          break;
        case "finaltrjson":
          return {backcolor: "#FFFF20", color:"#FFFFFF"};
          break;
        case "voiceover":
          return {backcolor: "#FFFF20", color:"#FFFFFF"};
        case "sequences":
          return {backcolor: "#800080", color:"#FFFFFF"};
      }
  }


export function drawStabilo(ctx, color, rect) {

  
  ctx.save();

  const waveAmplitude = 3;
  const waveLength = 16;
  const passes = 3;
  const alpha = 0.75;   // opacité plus forte pour fond sombre
  const blur = 1.5;

  // Mode de fusion qui éclaire plutôt que d’assombrir
  ctx.globalCompositeOperation = "screen";
  ctx.filter = `blur(${blur}px)`;
  ctx.fillStyle = color;

  for (let p = 0; p < passes; p++) {
    //ctx.globalAlpha = alpha + (Math.random() * 0.1 - 0.05);
    ctx.globalAlpha= 0.50;
    ctx.beginPath();

    const offsetY = 0.5; // (Math.random() - 0.5) * 3;

    // Bord supérieur tremblant
    ctx.moveTo(rect.x, rect.y + offsetY);
    for (let x = rect.x; x <= rect.x + rect.width; x += 5) {
      const y = rect.y + offsetY + Math.sin((x / waveLength) + p) * waveAmplitude;
      ctx.lineTo(x, y);
    }

    // Bord inférieur tremblant
    for (let x = rect.x + rect.width; x >= rect.x; x -= 5) {
      const y = rect.y + rect.height + offsetY + Math.sin((x / waveLength) + p + 1) * waveAmplitude;
      ctx.lineTo(x, y);
    }

    ctx.closePath();
    ctx.fill();
  }

  ctx.restore();
}  


export function drawStabiloFondClair(ctx, color, rect) {
   ctx.save();

  // Réglages de rendu
  const waveAmplitude = 3;   // irrégularité verticale
  const waveLength = 16;     // longueur d’onde
  const passes = 3;          // nombre de coups de surligneur
  const alpha = 0.5;        // opacité par passage (plus fort qu’avant)
  const blur = 1.5;          // flou plus léger pour garder la luminosité

  ctx.globalCompositeOperation = "multiply";
  ctx.filter = `blur(${blur}px)`;
  ctx.fillStyle = color;

  for (let p = 0; p < passes; p++) {
    ctx.globalAlpha = alpha + (Math.random() * 0.1 - 0.05);
    ctx.beginPath();

    const offsetY = (Math.random() - 0.5) * 3; // légère variation verticale

    // Bord supérieur tremblant
    ctx.moveTo(rect.x, rect.y + offsetY);
    for (let x = rect.x; x <= rect.x + rect.width; x += 5) {
      const y = rect.y + offsetY + Math.sin((x / waveLength) + p) * waveAmplitude;
      ctx.lineTo(x, y);
    }

    // Bord inférieur tremblant
    for (let x = rect.x + rect.width; x >= rect.x; x -= 5) {
      const y = rect.y + rect.height + offsetY + Math.sin((x / waveLength) + p + 1) * waveAmplitude;
      ctx.lineTo(x, y);
    }

    ctx.closePath();
    ctx.fill();
  }

  ctx.restore();
}


  /**
 * Dessine un effet stabilo (surlignage translucide et doux)
 * @param {CanvasRenderingContext2D} ctx - Contexte 2D du canvas
 * @param {string} color - Couleur du stabilo (ex: "#ffeb3b")
 * @param {{x:number, y:number, width:number, height:number}} rect - Zone à surligner
 */
export function drawStabiloComputer(ctx, color, rect) {
  ctx.save();

  // Crée un dégradé vertical léger pour simuler le stabilo
  const grad = ctx.createLinearGradient(rect.x, rect.y, rect.x, rect.y + rect.height);
  grad.addColorStop(0, color + "80"); // ~50% opacity
  grad.addColorStop(1, color + "40"); // ~25% opacity

  // Halo flou : on dessine d'abord un rectangle flou en dessous
  ctx.globalAlpha = 0.8;
  ctx.filter = "blur(8px)";
  ctx.fillStyle = grad;
  ctx.fillRect(rect.x - 2, rect.y - 2, rect.width + 4, rect.height + 4);

  // Trait principal du surligneur
  ctx.filter = "none";
  ctx.globalAlpha = 0.35;
  ctx.globalCompositeOperation = "multiply"; // pour que les surlignages se superposent comme du vrai stabilo
  ctx.fillStyle = color;
  ctx.fillRect(rect.x, rect.y, rect.width, rect.height);

  ctx.restore();
}

